module.exports = new __parcel__URL__("Charlie_Text-Bold.dc235128.woff").toString();